import _isEqual from 'lodash/isEqual';

export default function isEqual(a: any, b: any)
{
    return _isEqual(a, b);
}
